import { render, staticRenderFns } from "./row_1_2.vue?vue&type=template&id=6e86a24a&"
import script from "./row_1_2.vue?vue&type=script&lang=js&"
export * from "./row_1_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/layout/row_1_2.vue"
export default component.exports